import styled from "styled-components";

export const RaffleRow = styled.button`
  display: grid;
  /* hora | nombre (flexible) | premio (se adapta al texto: mínimo 16 %, hasta 30 %) | estado (icono y texto) */
  grid-template-columns: 16% minmax(0, 1fr) fit-content(30%) fit-content(14%);
  container-type: inline-size;
  width: 100%;
  min-height: 116px;
  margin: 0 0 16px;
  padding: 0;
  box-sizing: border-box;
  border: 3px solid;
  border-color: #fff0b2 #b18236 #c99d4b #ebcb83;
  border-radius: 22px;
  overflow: hidden;
  background: ${(props) => props.theme.raffleItemBackground || props.theme.homeBackground};
  box-shadow:
    inset 0 0 0 1px #7d4926,
    inset 0 6px 9px -3px #35000099,
    inset 4px 0 7px -3px #35000066,
    inset 0 -1px 0 #ffeabc99;
  cursor: pointer;
  color: #fff8ec;
  font-family: Arial, sans-serif;
  align-items: stretch;
  text-align: center;
  transition: border-color 160ms ease, box-shadow 160ms ease;

  &:hover {
    border-color: #fff6cc #c79b50 #dab269 #f5dda3;
    box-shadow:
      inset 0 0 0 1px #8c5424,
      inset 0 6px 9px -3px #35000099,
      inset 4px 0 7px -3px #35000066,
      inset 0 -1px 0 #ffeabcb3;
  }
  &:focus-visible {
    outline: 3px solid #fff1bb;
    outline-offset: 3px;
  }
  @media (max-width: 900px) {
    grid-template-columns: minmax(128px, 26%) minmax(0, 1fr);
  }
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;
export const RowCell = styled.span`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 0;
  padding: 22px 18px;
  font-size: clamp(20px, 2.1vw, 38px);
  font-weight: 700;
  line-height: 1.2;
  overflow-wrap: anywhere;
`;
export const TimeCell = styled(RowCell)`
  align-self: center;
  color: #ffffff;
  background: transparent;
  border-right: 1px solid #d5ab4f66;
  margin: 22px 0;
  padding: 12px;
  white-space: nowrap;
  font-size: clamp(20px, 2.2vw, 40px);
  @media (max-width: 480px) {
    border-right: 0;
    border-bottom: 1px solid #d5ab4f66;
    margin: 0 16px;
    padding: 12px;
  }
`;
export const NameCell = styled(RowCell)`
  align-items: flex-start;
  text-align: left;
  padding-left: clamp(20px, 4vw, 64px);
  gap: 8px;
  @media (max-width: 900px) { padding-left: 20px; }
`;
export const RaffleType = styled.span`
  color: #ffebbe;
  font-size: clamp(14px, 1.3vw, 22px);
  font-weight: 700;
`;
export const NameWithModel = styled(NameCell)`
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding-left: clamp(12px, 1.5vw, 24px);
  gap: clamp(8px, 1vw, 16px);
`;
export const NameDetails = styled.span`
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 4px;
  font-family: 'Open Sans', sans-serif;
  font-size: clamp(22px, 2.3vw, 42px);
  font-weight: 800;
`;
export const PrizeCell = styled(RowCell)`
  color: #ffe582;
  text-transform: uppercase;
  padding-inline: 12px;
  box-sizing: border-box;
  /* ancho mínimo = 16 % de la fila; la columna crece desde ahí según el texto */
  @media (min-width: 901px) { min-width: 16cqw; }
`;
export const StatusCell = styled(RowCell)`
  align-self: center;
  gap: 4px;
  @media (min-width: 901px) { min-width: 8cqw; }
  border-left: 1px solid #d5ab4f66;
  margin: 22px 0;
  padding: 12px;
  font-size: clamp(17px, 1.75vw, 30px);
  @media (max-width: 480px) {
    border-left: 0;
    border-top: 1px solid #d5ab4f66;
    margin: 0 16px 8px;
  }
`;
export const StatusLabel = styled.span`
  color: #ffe2a8;
  font-family: 'Open Sans', sans-serif;
  font-size: clamp(11px, 1.05vw, 17px);
  font-weight: 700;
  letter-spacing: 0.06em;
  line-height: 1.1;
  text-transform: uppercase;
  white-space: nowrap;
`;
export const StatusIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #f5ca65;
  font-size: clamp(30px, 2.5vw, 46px);
  line-height: 1;
  & > svg { display: block; width: 1em; height: 1em; stroke-width: 2.5; }
`;
